/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

import type { WarningDefinition } from './warning-codes';

type TemplatePrimitive = string | number | boolean;
export type TemplateArgs = TemplatePrimitive[] | Record<string, TemplatePrimitive>;

function formatWarningMessage(template: string, args?: TemplateArgs): string {
  if (!args) {
    return template;
  }

  if (Array.isArray(args)) {
    return args.reduce<string>(
      (message, value, index) => replacePlaceholder(message, `{${index}}`, String(value)),
      template,
    );
  }

  return Object.entries(args).reduce<string>(
    (message, [key, value]) => replacePlaceholder(message, `{${key}}`, String(value)),
    template,
  );
}

export function logWarning(warning: WarningDefinition, args?: TemplateArgs): void {
  if (typeof console === 'undefined' || typeof console.warn !== 'function') {
    return;
  }

  const message = formatWarningMessage(warning.template, args);
  console.warn(`${warning.code} - ${message}`);
}

function replacePlaceholder(message: string, placeholder: string, value: string): string {
  return message.split(placeholder).join(value);
}
